<template>
  <div>
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="content">
        <div class="pull-right">
          <div class="btn-close" @click="toggleCloseModal"></div>
        </div>
        <div class="tab">
          <div class="branding-modal-content">
            <div class="brand-title">
              <h1>Branding</h1>
            </div>
            <form @submit.prevent="handleSubmission">
              <div class="brand-setting-main-wrapper">
                <div class="brand-setting-inner-wrapper">
                  <div class="branding-item">
                    <span class="branding-item-title">Schriftart:</span>
                    <input
                      type="text"
                      v-model="brandForm.fontType"
                      required
                      defaultValue="Helvetica Neue"
                    />
                  </div>
                  <div class="branding-item">
                    <span class="branding-item-title">Primäre Rundung:</span>

                    <input
                      type="number"
                      min="0"
                      v-model="brandForm.primaryBordarRadius"
                      max="100"
                      required
                      defaultValue="0"
                    />
                  </div>
                  <div class="branding-item">
                    <span class="branding-item-title">Sekundäre Rundung:</span>

                    <input
                      type="number"
                      min="0"
                      max="100"
                      required
                      v-model="brandForm.secondaryBordarRadius"
                      defaultValue="0"
                    />
                  </div>
                  <div class="branding-item">
                    <span class="branding-item-title">Schriftfarbe:</span>
                    <input type="color" v-model="brandForm.textColor" />
                  </div>
                  <div class="branding-item">
                    <span class="branding-item-title">Primäre Farbe:</span>
                    <input type="color" v-model="brandForm.primaryBrandColor" />
                  </div>
                  <div class="branding-item">
                    <span class="branding-item-title">Sekundäre Farbe:</span>
                    <input
                      type="color"
                      v-model="brandForm.secondaryBrandColor"
                    />
                  </div>
                </div>
                <div class="brand-setting-preview-wrapper">
                  <div class="preview-items-main">
                    <h4>Beispiele</h4>
                    <div class="branding-item">
                      <h1
                        :style="{
                          color: getFontColor,
                          'font-family': getFontType,
                        }"
                        class="branding-item-preview-title"
                      >
                        Ein Titel
                      </h1>
                      <p
                        :style="{
                          color: getFontColor,
                          'font-family': getFontType,
                        }"
                        class="branding-item-preview-description"
                      >
                        Beschreibungstext
                      </p>
                    </div>
                    <div class="branding-item">
                      <div
                        :style="{
                          color: getFontColor,
                          'font-family': getFontType,
                          background: getPrimaryBrandColor,
                          'border-radius': getPrimaryBorderRadius,
                        }"
                        class="option-preview-button"
                      >
                        Option 1
                      </div>
                    </div>
                    <div class="branding-item">
                      <div
                        class="preview-box"
                        :style="{
                          color: getFontColor,
                          'border-radius': getSecondaryBorderRadius,
                          'font-family': getFontType,
                        }"
                      >
                        <img src="../../assets/img/user.svg" />
                        <div>Option 2</div>
                      </div>
                    </div>
                    <div class="branding-item">
                      <Button
                        disabled
                        :style="{
                          color: '#ffffff',
                          'font-family': getFontType,
                          background: getPrimaryBrandColor,
                          'border-radius': getSecondaryBorderRadius,
                        }"
                        >Start</Button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <button class="brand-setting-save-button">Speichern</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrandSettingModel',
  data() {
    return {
      brandForm: {
        fontType: 'Helvetica Neue',
        primaryBordarRadius: 0,
        secondaryBordarRadius: 0,
        textColor: '#8f8f8f',
        primaryBrandColor: '#000000',
        secondaryBrandColor: '#000000',
      },
    };
  },
  props: {
    isBrandSettingModelOpen: {
      type: Boolean,
      default: false,
    },
    process: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    getFontColor() {
      return this.brandForm.textColor;
    },
    getFontType() {
      return this.brandForm.fontType;
    },
    getPrimaryBrandColor() {
      return this.brandForm.primaryBrandColor;
    },
    getSecondaryBrandColor() {
      return this.brandForm.secondaryBrandColor;
    },
    getPrimaryBorderRadius() {
      return this.brandForm.primaryBordarRadius + 'px';
    },
    getSecondaryBorderRadius() {
      return this.brandForm.secondaryBordarRadius + 'px';
    },
  },
  methods: {
    toggleCloseModal() {
      this.$emit('close');
    },
    handleSubmission() {
      this.$emit('saveBrandSettings', this.brandForm);
    },
  },
  created() {
    if (this.process.style) {
      this.brandForm = this.process.style;
    }
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}
.heading {
  padding: 15px 15px 0px;
  text-align: center;
}
.modal {
  background: #ffffff;
  border-radius: 19px;
  box-shadow: 0 0 20px rgb(31 37 50 / 20%);
  display: block;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  left: 0;
  right: 0;
  margin: auto;
  top: 0;
  bottom: 0;
  min-width: 300px;
  max-width: 40%;
  width: 100%;
  max-height: 605px;
  height: 100%;
  position: absolute;
}

.modal.shift-right {
  right: 0%;
  top: 0%;
  height: 100%;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}
/**** */

.branding-modal-content,
.branding-modal-content * {
  box-sizing: border-box;
}

.branding-modal-content {
  padding: 20px 31px;
}
.branding-modal-content .brand-title h1 {
  font-size: 25px;
  margin-bottom: 20px;
}

.brand-setting-main-wrapper {
  display: flex;
  margin: 0 -10px;
}

.brand-setting-main-wrapper > div {
  width: 50%;
  padding: 0 10px;
}
.branding-modal-content .branding-item-title {
  font-size: 14px;
  display: block;
  text-align: left;
  color: #222;
  margin-bottom: 8px;
  font-weight: 600;
}

.branding-modal-content select {
  width: 100%;
  padding: 5px 5px;
  outline: none;
  border: 1px solid #000000;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
}

.branding-modal-content .branding-item {
  margin-bottom: 16px;
}

.branding-modal-content input[type='number'] {
  width: 70px;
  border: 1px solid #000;
  border-radius: 4px;
  padding: 5px 8px;
  color: #000;
  outline: none;
}
.branding-modal-content input[type='color'] {
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 6px;
  outline: none;
  border: 1px solid #0000;
  overflow: hidden;
  cursor: pointer;
}
.preview-items-main {
  padding: 10px;
  height: 100%;
  background: rgb(247 247 247 / 80%);
}

.preview-items-main h4 {
  font-size: 16px;
  color: #000000;
  font-weight: 600;
  margin-bottom: 20px;
}

.preview-items-main .branding-item-preview-title {
  font-size: 16px;
  text-align: left;
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
}
.preview-items-main .branding-item-preview-description {
  text-align: left;
  margin-bottom: 20px;
}
.preview-items-main .branding-item button {
  outline: none;
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 4px 16px;
  font-size: 14px;
}

.preview-items-main .branding-item {
  text-align: left;
}
.preview-items-main .preview-box {
  padding: 16px;
  font-size: 16px;
  min-height: 100px;
  border: 1px solid #e7e7e7;
  border-radius: 4px;
}

.preview-items-main .preview-box img {
  width: 34px;
  margin-bottom: 39px;
}

.brand-setting-save-button {
  cursor: pointer;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.951);
  border: 3px solid rgba(0, 0, 0, 0.916);
  background-color: rgba(0, 0, 0, 0.916);
  border-radius: 0.375em;
  font-weight: 400;
  line-height: 23px;
  padding: 0.6rem 1.6rem;
  font-size: 0.9375rem;
  margin-top: 25px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}
.preview-items-main .option-preview-button {
  border-color: white;
  width: fit-content;
  height: fit-content;
  background: #ffffff;
  margin-right: 8px;
  margin-bottom: 15px;
  cursor: pointer;
  text-align: center;
  border: 1px solid rgb(221, 221, 221);
  outline: none;
  transition-property: -ms-transform, -webkit-transform, transform,
    background-color, border-color;
  transition-duration: 0.15s;
  padding: 10px 20px;
  min-width: 59px;
  font-size: 13px;
}

.start-dropdown ::v-deep .customDropdown {
  width: 100% !important;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  height: 37px;
  color: #464d5d;
  justify-content: space-between;
}

::v-deep .start-dropdown {
  width: 100%;
}
::v-deep .start-dropdown .dropdown-menu {
  width: 100%;
}
.branding-modal-content input[type='text'] {
  width: 100%;
  border: 1px solid #000;
  border-radius: 4px;
  padding: 5px 8px;
  color: #000;
  outline: none;
}
</style>
